import { useTranslation } from 'react-i18next';

interface FieldErrorProps {
  messageKey: string | null;
}

export function FieldError({ messageKey }: FieldErrorProps) {
  const { t } = useTranslation();
  if (messageKey === null || messageKey.length === 0) {
    return null;
  }
  return <p className="text-xs font-medium text-zooerrortext mt-1">{t(messageKey)}</p>;
}
